import axios from "axios";
import {Link} from 'react-router-dom';
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function IpPayment(){
    const [opData,setopData] = useState([]);
    const [amount, setAmount] = useState(0);
    const [iptotData,setIptotData] = useState([]);
    const [balance, setBalance] = useState(0);
    const {ip_id, id}=useParams();

    useEffect(() => {
        try{
            axios.get(baseUrl+'ip-pay/'+ip_id+'/'+id+'/')
            .then(function (response) {
                setopData(response.data);
                setAmount(response.data[0].advance);
                setBalance(0);
            });
        }catch(error){
            console.log(error);
        }
    },[]);
  useEffect(() => {
    fetchtotData();
  }, []);

  function fetchtotData() {
    axios.get(baseUrl + "view-ip-tot/" + ip_id)
      .then(response => {
        setIptotData(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

   const handleAmountChange = (event) => {
    let newAmount = parseInt(event.target.value, 10);
    const maxAmount = opData[0].advance;
     if (newAmount > maxAmount) {
        newAmount = maxAmount;
    }
     setAmount(newAmount);
    setBalance(maxAmount - newAmount);
};

    const handlePaymentTypeChange = (event) => {
      const value = event.target.value;
      if (value === 'creditpay') {
        setAmount(0);
        setBalance(opData[0].advance);
      } else {
        setAmount(opData[0].advance);
        setBalance(0);
      }
    }

   const handleFormSubmit = (e) => {
  e.preventDefault();

  const dbType = document.getElementById('dbType').value;

  // 🛑 Safety checks
  if (!opData.length) {
    Swal.fire('Error', 'Patient data not loaded', 'error');
    return;
  }

  if (!iptotData) {
    Swal.fire('Error', 'Total data not loaded', 'error');
    return;
  }

  axios.post(`${baseUrl}get_sale_ip/`)
    .then(res => {
      const sale_ip = res.data.value;

      const formData = new FormData();
      formData.append('paid', amount);
      formData.append('balance', balance);
      formData.append('invoice', sale_ip);
      formData.append('mode', dbType);
      formData.append('cashier', userName);
      formData.append('status', '2');

      return axios.post(`${baseUrl}ip-payment/${id}/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => ({ response, sale_ip }));
    })
    .then(({ response, sale_ip }) => {
      if (response.status === 200 || response.status === 201) {

        // ✅ Handle both array/object safely
        const data = Array.isArray(iptotData) ? iptotData[0] : iptotData;

        if (!data) {
          Swal.fire('Error', 'Invalid total data structure', 'error');
          return;
        }

        const tot_invoiced = parseFloat(data.tot_invoiced || 0) + parseFloat(opData[0]?.advance || 0);
        const tot_paid = parseFloat(data.tot_paid || 0) + parseFloat(amount || 0);
        const tot_balance = parseFloat(data.tot_balance || 0) + parseFloat(balance || 0);
        const remain_balance = parseFloat(data.remain_balance || 0) + parseFloat(amount || 0);
        const IpId = data.id;

        const updateData = new FormData();
        updateData.append('tot_invoiced', tot_invoiced.toFixed(2));
        updateData.append('tot_paid', tot_paid.toFixed(2));
        updateData.append('tot_balance', tot_balance.toFixed(2));
        updateData.append('remain_balance', remain_balance.toFixed(2));
        updateData.append('addedby', userName);
        updateData.append('ip_add', ipAddress);
        updateData.append('location', userLocation);

        return axios.put(`${baseUrl}update-ip-tot/${IpId}/`, updateData)
          .then(() => {
            Swal.fire({
              title: 'Payment Success and Invoice is Generated',
              icon: 'success',
              timer: 3000,
              showConfirmButton: false
            });

            setTimeout(() => {
              window.location.href = `/ip-invoice/${sale_ip}/`;
            }, 2000);
          });
      }
    })
    .catch(error => {
      console.error(error);
      Swal.fire('Error!', 'Something went wrong. Please try again.', 'error');
    });
};

    return (
        <section className="container mt-4">
            <div className="row">
              <div className='col-md-9 col-12 mb-2'>
                <div className="row">
                    <h3 className="text-center"> IP Payment</h3>
                    <div className="table-responsive">
                      <table className="erp-table-modern">
                        <thead>
                              <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                                <th>IP Id</th>
                                <th>Patient Id</th>
                                <th>Patient Name</th>
                                <th>Addedby</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {opData.map((row,index) =>
                                  <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                                    <td>{ip_id}</td>
                                    <td>{row.ip.pat.pat_id}</td>
                                    <td>{row.ip.pat.patient}</td>
                                    <td>{row.addedby}</td>
                                    <td>{row.advance}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <form>
                        <label>Choose Payment Type</label>
                        <select name="dbType" id="dbType" onChange={handlePaymentTypeChange}>
                           <option value="cash">Cash</option>
                           <option value="card">Card</option>
                           <option value="UPI">UPI</option>
                        </select>
                        <div className="form-group mt-3" >
                            <label style={{ fontWeight: 'bold' }}>Amount: &nbsp;</label>
                            <div className="input-group">
                                <div className="input-group-addon me-2 ">&#8377;</div>
                                <input type="number" name="amount" id="amount" value={amount} onChange={handleAmountChange} max={amount}/>
                            </div>
                        </div>
                        <div className="form-group mt-3" >
                            <label style={{ fontWeight: 'bold' }}>Balance Amount: &nbsp;</label>
                            <div className="input-group">
                                <div className="input-group-addon me-2 ">&#8377;</div>
                                <input type="number" name="balance" id="balance" value={balance}
                                    onChange={handleAmountChange} readOnly />
                            </div>
                        </div>
                         <button type="button" onClick={handleFormSubmit} className="btn btn-primary mt-4">
                         Submit</button>
                   </form>
              </div>
            </div>
            </div>
            </div>
        </section>

)
}

export default IpPayment;